module.exports = __webpack_public_path__ + "img/SL-M-140-220.ccea7586.svg";